import { IModal } from '@ibiz-template/runtime';
import { useNamespace } from '@ibiz-template/vue3-util';
import { defineComponent, PropType } from 'vue';
import './print-html.scss';

export const PrintHtml = defineComponent({
  name: 'PrintHtml',
  props: {
    modal: {
      type: Object as PropType<IModal>,
      required: true,
    },
    content: {
      type: String,
      default: '',
    },
    filename: {
      type: String,
      default: '',
    },
  },
  setup() {
    const ns = useNamespace('print-html');

    return { ns };
  },
  render() {
    return (
      <div class={this.ns.b()}>
        <div class={this.ns.e('header')}>{this.filename}</div>
        <div class={this.ns.e('content')} v-html={this.content}></div>
      </div>
    );
  },
});
